import * as Icons from "lucide-react";
import SectionReveal from "@/components/effects/SectionReveal";
import { SERVICES } from "@/data/content";
import { TID } from "@/constants/testIds";

const Services = () => {
    return (
        <section id="services" className="relative py-24 md:py-40">
            <div className="container-x">
                <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
                    <SectionReveal>
                        <p className="overline">04 — Services</p>
                        <h2
                            className="mt-4 text-3xl font-medium tracking-tight text-white sm:text-4xl md:text-5xl"
                            style={{ fontFamily: "'General Sans', sans-serif" }}
                        >
                            What I build.
                        </h2>
                    </SectionReveal>
                    <SectionReveal delay={0.15}>
                        <p className="max-w-md text-sm text-brand-muted md:text-base">
                            End-to-end capability across product, design, engineering, and growth — so I can own the
                            outcome, not just a slice of the delivery.
                        </p>
                    </SectionReveal>
                </div>

                <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-white/[.08] bg-white/[.04] sm:grid-cols-2 lg:grid-cols-3">
                    {SERVICES.map((s, i) => {
                        const Icon = Icons[s.icon] || Icons.Star;
                        return (
                            <SectionReveal key={s.title} delay={i * 0.03} className="bg-[#0a0a0a]">
                                <div
                                    data-testid={TID.serviceCard(i)}
                                    className="group relative flex h-full flex-col gap-4 p-8 transition-colors hover:bg-[#0f0f0f]"
                                >
                                    <div className="flex items-center gap-3">
                                        <span className="grid h-10 w-10 place-items-center rounded-xl border border-white/[.08] bg-white/[.03] text-white transition-colors group-hover:border-brand-primary/40 group-hover:text-brand-primary">
                                            <Icon className="h-5 w-5" strokeWidth={1.6} />
                                        </span>
                                        <span className="text-xs uppercase tracking-widest text-brand-muted">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                    </div>
                                    <h3
                                        className="mt-2 text-lg font-medium text-white md:text-xl"
                                        style={{ fontFamily: "'General Sans', sans-serif" }}
                                    >
                                        {s.title}
                                    </h3>
                                    <p className="text-sm leading-relaxed text-brand-muted">{s.desc}</p>
                                    <span
                                        aria-hidden
                                        className="absolute bottom-6 right-6 h-6 w-6 -rotate-45 opacity-0 transition-all duration-500 group-hover:rotate-0 group-hover:opacity-100"
                                    >
                                        <Icons.ArrowUpRight className="h-6 w-6 text-brand-primary" />
                                    </span>
                                </div>
                            </SectionReveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Services;
